import { HugeiconsIcon } from "@hugeicons/react";
import { BubbleChatIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { ChatBadge } from "shared/app/MessagePopup/components/ChatBadge";

/**
 * "Chat" entry point into the message pop-up (CRM-1133) with its unread badge.
 * Shared by the application header and the applicant report card.
 */
export const ChatButton = ({
  unreads,
  onClick,
  className
}: {
  unreads: number;
  onClick: () => void;
  className?: string;
}) => (
  <Button
    variant={ButtonVariant.BASE}
    size={ButtonSize.SM}
    onClick={onClick}
    className={className}
  >
    <div className="flex items-center gap-2">
      <span className="relative inline-flex shrink-0">
        <HugeiconsIcon icon={BubbleChatIcon} size={20} strokeWidth={1.5} />
        <ChatBadge count={unreads} />
      </span>
      <span>Chat</span>
    </div>
  </Button>
);
